import {
  CommonContentPageEntity,
  CommonContentPageFormEntity,
  CommonContentPagesResponse,
  CommonContentPageRequest,
  CommonContentAssetContentType,
  CommonContentPageResponse,
} from 'src/types'

export const CommonContentPageTranslator = {
  toEntity: (page: CommonContentPageResponse): CommonContentPageEntity => {
    return {
      id: page.id,
      name: page.name,
      priority: page.priority,
      annotation: page.annotation ?? undefined,
      isPublic: page.meta.isPublic,
      displayConsumer: page.meta.displayConsumer,
      designFormat: page.meta.designFormat as 'dropdown' | 'gallery',
      icon: page.meta.icon,
      assets: page.assets.map(asset => {
        const contentType: CommonContentAssetContentType =
          asset.externalLink && asset.externalLink !== ''
            ? 'link'
            : asset.meta.fileName && /\.(jpg|png|gif)$/i.test(asset.data.url)
            ? 'img'
            : asset.meta.fileName && /\.(pdf)$/i.test(asset.data.url)
            ? 'pdf'
            : asset.meta.fileName && /\.(mp4)$/i.test(asset.data.url)
            ? 'video'
            : 'empty'

        const fileName =
          contentType !== 'empty' && contentType !== 'link'
            ? asset.data.url.match(/[^&/?\\]+\.\w{3,4}(?=([&?].*$|$))/)?.[0]
            : undefined

        return {
          id: asset.id,
          pageId: page.id,
          name: asset.name,
          category: asset.category,
          priority: asset.priority,
          fileSize: asset.fileSize,
          externalLink: asset.externalLink,
          fileName,
          uploadedAt: new Date(asset.meta.uploadedAt),
          uploadedById: asset.meta.UploadedWorksUserBy,
          url: asset.data.url,
          thumbUrl: asset.data.thumbUrl || undefined, // 空文字を undeifned にしたいため ?? ではなく || を使う
          contentType,
        }
      }),
    }
  },

  toEntities: (response: CommonContentPagesResponse): CommonContentPageEntity[] => {
    const { commonPages } = response
    return commonPages?.map(page => CommonContentPageTranslator.toEntity(page)) ?? []
  },

  toFormEntity: (entity: CommonContentPageEntity): CommonContentPageFormEntity => {
    return {
      ...entity,
    }
  },

  toRequest: (formEntity: CommonContentPageFormEntity): CommonContentPageRequest => {
    return {
      name: formEntity.name,
      priority: formEntity.priority,
      annotation: formEntity.annotation ?? '',
      meta: {
        isPublic: formEntity.isPublic,
        displayConsumer: formEntity.displayConsumer,
        designFormat: formEntity.designFormat,
        icon: formEntity.icon,
      },
    }
  },
}
